<template>
  <div class="print">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Print",
};
</script>

<style scoped>
</style>
